import * as Yup from 'yup';

const schema = Yup.object().shape({
  codigo: Yup.string()
    .nullable()
    .default(null)
    .required('É necessário digitar um código para a lotação!'),
  nome: Yup.string()
    .nullable()
    .default(null)
    .required('É necessário digitar um nome para a lotação!'),
  estruturaOrganizacionalPai: Yup.object().nullable().default(null),
});

export default schema;
